<div class=" mt-4">
    
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                               
                                <div class="text-center">
                                    <a class="view-h gary-t  "> PayOut View Beneficiary </a>
                                    
                                </div>

                                <div class="pt-3">
                                    <div class=" ">
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>PayOut Beneficiary KeyId</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.PayOutBeneficiaryKeyId}}
                                                                             </div>
                                        </div>
                                        <div class="row mb-3">
              
                                          <div class="col-4 p-0"> <label>Payout Customer keyId</label> </div>
                                          
                                          <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}
                                                                           </div>
                                      </div>
                                      <div class="row mb-3">
              
                                          <div class="col-4 p-0"> <label>Beneficiary Name</label> </div>
                                          
                                          <div class="col-7 p-0 view-text robot"> {{rows.BeneficiaryName}}</div>
                                      </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>BankCode Type</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.BankCodeType}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Bank Name</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.BankName}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> Branch Name</label></div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.BranchName}}</div>
                                        </div>
                                      
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Bank Code/IFSC Code </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.BankCode}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label> Account Number </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.AccountNumber}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> Bank AccountType </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.BankAccountType}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> Bank Country</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot">   {{rows.BankCountry }}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Verification Status</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.VerificationStatus}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label> Verification Response </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.VerificationResponse}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label>  UpiVpa</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.UpiVpa}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label> Prefer PayOutAccount  </label> </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.PreferPayOutAccount}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label>  Datetime </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.UpdatedDatetime| date:'d/M/yy, h:mm a'}}</div>
                                        </div>
                                       
                                        <div class="text-right pt-2">
                                       
                                          
                                            <button class="btn dash-btns"   id="deleteben"     (click)="openConfirmationDialog()">Delete Beneficiary</button>
                                      </div>
              
              
              
                                        
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="text-center">
                      <div class="card-1 p-2">
                        <img src="https://fastswiff.com/assets/img/security.png" class="w-100" alt="">
          
                      </div>
                    </div>
                  </div>
            </div>
        </div>
    </section>
</div> 






